// src/main.tsx
// Updated main.tsx with SubscriptionProvider

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { DataCacheProvider } from './contexts/DataCacheContext';
import { FestivalThemeProvider } from './contexts/FestivalThemeContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';

createRoot(document.getElementById('root')!).render(
  <FestivalThemeProvider>
    <StrictMode>
      <DataCacheProvider>
        <SubscriptionProvider>
          <App />
        </SubscriptionProvider>
      </DataCacheProvider>
    </StrictMode>
  </FestivalThemeProvider>
);